import { omit } from 'lodash'
import moment from 'moment'

export function makeFields (data) {
  const excludeEditData = [
    'id',
    'school_id',
    'class_id',
    'session_id',
    'online_application_form_id',
    'application_id',
    'applicant_marks',
    'subject_group',
    'board',
    'board_roll_no',
    'result_status',
    'year_of_passing',
    'exam_total_score',
    'pc_score',
    'grade',
    'ec1_name',
    'ec1_when',
    'ec1_for',
    'ec2_name',
    'ec2_when',
    'ec2_for',
    'last_school_name',
    'last_school_type',
    'last_school_medium',
    'subject_group_id',
    'photo',
    'document',
    'sports_person',
    'sport_cert',
    'password',
    'step',
    'form_status',
    'status',
    'token',
    'uniforms',
    'order_id',
    'created_at',
    'updated_at',
    'deleted_at',
    'student_id',
  ]
  const editData = omit(data, excludeEditData)
  editData.dob = moment(editData.dob)

  return { ...editData }
}
